<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Filtri</span>
  <button mat-icon-button type="button" aria-label="Chiudi" class="close-button" (click)="close()">
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>Dal</mat-label>
    <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="dateFrom" placeholder="GG/MM/AAAA" />
    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" />
    <mat-datepicker #dateFromPicker />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Al</mat-label>
    <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="dateTo" placeholder="GG/MM/AAAA" />
    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" />
    <mat-datepicker #dateToPicker />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Stato brogliaccio</mat-label>
    <mat-select multiple [(ngModel)]="selectedStatuses">
      @for (status of statusOptions; track status.value) {
        <mat-option [value]="status.value">{{ status.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container">
  <button matButton type="button" (click)="reset()">Cancella</button>
  <button matButton="filled" type="button" (click)="apply()">Applica</button>
</mat-dialog-actions>
